export enum FlowUnit {
  LitresPerSecond = 'l/s',
  GallonsPerSecond = 'gal/s',
}
